import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid } from "@material-ui/core";

import ProfileIncompleteWarning from "../Forms/buypermits/ProfileIncompleteWarning";
import { getProfileStates } from "../../store/profile/action";
import { getUserContextData } from "../../store/login/selector";
import AddPermitPage from "./addPermitPage";
import ViewPermitCart from "./viewPermitCart";
import { getDriverPermitListStates, getDriverPermitResionText } from "../../store/permitList/action";
import {
  getBuyPermitPaymentMethods,
  getCheckoutSelectAddressStates,
  getCheckoutSelectEmailStates,
  getCheckoutSelectPhoneStates,
  setBuyPermitEditVehicle,
  resetBuyPermitSelectedPermit
} from "../../store/buyPermits/action";
import { getProfileData } from "../../store/profile/selector";
import { fetchRequiredFiled } from "../../store/ProfileRequiredField/action";
import { getDriverViewOrderStates } from "../../store/vieworder/action";
import {
  getIncompleteProfileDetails,
  isProfileFullyCompleteForPermits,
  shouldShowProfileIncompleteForm,
} from "../../utils/profile-validation-utils";


const BuyPermitsPage = (props) => {
  const { StylingItem } = props;

  let location = useLocation();
  const dispatch = useDispatch();

  const profileStore = useSelector(getProfileData);
  const { clientName } = profileStore || {};

  const [selectedDate, setSelectedDate] = useState([]);
  const [permitType, setPermitType] = useState("");


  const permitList = useSelector(
    (state) => state.driverPermitListReducer.driverPermitListStateList
  );

  const endUserId = profileStore?.endUserAccountEntity?.id;
  const driverViewOrderStateList = useSelector(
    (state) => state.driverViewOrderReducer.driverViewOrderStateList
  );

  const cartPermits = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitSelectedPermits || []
  );


  useEffect(() => {
    dispatch(setBuyPermitEditVehicle({ permit_id: 0, vehicleEditList: 0 }));
  }, [driverViewOrderStateList, profileStore]);


  var driverStatus =
    profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.filter(
      (item, index) => {
        if (item?.name == "Status") {
          return item;
        }
      }
    );

    var driverBAStatus = profileStore &&  profileStore?.endUserAccountEntity &&
    profileStore?.endUserAccountEntity?.driverAttributes?.map((item => {
      if(item.name !== 'VIP'){
        return item.value
      }
    }));


  var status = Array.isArray(driverStatus) && driverStatus[0]?.value;

  let statusWithoutUndefined = driverBAStatus?.filter((ele)=> !!ele);


  const profileUpdateData = useSelector(
    (state) =>
      state?.profileState?.profileStateList?.endUserAccountEntity?.person
  );
  const ProfileRequiredFields = useSelector(
    (state) => state.profileRequired.ProfileRequiredFields
  );


  /** this effect will fetch profile detail from reducer   */
  useEffect(() => {
    if (profileStore && profileStore?.accountId) {
      dispatch(
        getDriverPermitListStates(profileStore && profileStore?.accountId)
      );
    }
    dispatch(getDriverPermitResionText(user?.user?.userGroup ||  profileStore?.permissionGroup))
  }, [profileStore?.accountId]);


  /** get user  from reducer  */
  const user = useSelector(getUserContextData);

  /** refetch the profile (profileStateList slice) whenever a username is available,
   *  so the page stays in sync on navigation/refresh instead of only after visiting My Account */
  const userName = profileStore?.userName || user?.user?.userName;
  useEffect(() => {
    if (userName) {
      dispatch(getProfileStates(userName));
    }
  }, [dispatch, userName]);

  const [toggleAddPermitPage, settoggleAddPermitPage] = useState(null);

  useEffect(() => {
    settoggleAddPermitPage(location?.state?.title);
  }, [location]);

  const handletoggleAddPermitPage = useCallback((type) => {
    settoggleAddPermitPage(type);
  });

  useEffect(() => {
    if (endUserId) {
      dispatch(getCheckoutSelectAddressStates({ accountId: endUserId }));
      dispatch(getCheckoutSelectEmailStates({ accountId: endUserId }));
      dispatch(getCheckoutSelectPhoneStates({ accountId: endUserId }));
      dispatch(getDriverViewOrderStates(endUserId));
    }
  }, [dispatch, endUserId, location.key]);

  useEffect(() => {
    const hasAttributes =
      profileStore?.endUserAccountEntity?.driverAttributes?.length > 0;
    if (status === "undefined" || !hasAttributes) {
      return;
    }
    dispatch(getBuyPermitPaymentMethods({ status: statusWithoutUndefined, clientUserName: user?.user?.userGroup }));
  }, [dispatch, endUserId, status, user?.user?.userGroup]);

  /** Dispatch Required Field API  */
  useEffect(() => {
    dispatch(fetchRequiredFiled(user?.user?.userGroup || profileStore?.permissionGroup));
  }, [clientName]);
  

  useEffect(() => {
    if (!Array.isArray(permitList) || permitList.length === 0) return;
    if (!Array.isArray(cartPermits) || cartPermits.length === 0) return;
  
    const permitById = new Map(permitList.map((p) => [p?.id, p]));
  
    let changed = false;
  
    const reconciledCart = cartPermits
      .map((item) => {
        const oldPermit = item?.permit;
        const freshPermit = permitById.get(oldPermit?.id);
  
        // If it no longer exists in the catalog, we remove it from the cart
        if (!freshPermit) {
          changed = true;
          return null;
        }
  
        // Keep user selection data
        const mergedPermit = {
          ...freshPermit,
          tdate: oldPermit?.tdate,
        };
  
        // Detect if something relevant has changed
        if (
          oldPermit?.price !== mergedPermit?.price ||
          oldPermit?.fee !== mergedPermit?.fee ||
          oldPermit?.name !== mergedPermit?.name ||
          oldPermit?.validStartDate !== mergedPermit?.validStartDate ||
          oldPermit?.validEndDate !== mergedPermit?.validEndDate
        ) {
          changed = true;
        }
  
        return {
          ...item,
          permit: mergedPermit,
        };
      })
      .filter(Boolean);
  
    if (
      changed ||
      reconciledCart.length !== cartPermits.length
    ) {
      dispatch(resetBuyPermitSelectedPermit(reconciledCart));
    }
  }, [permitList, cartPermits, dispatch]);
  const stylingVal = {
    backgroundColor: StylingItem && StylingItem?.bodyColor,
    fontFamily: StylingItem && StylingItem?.font,
    color: StylingItem && StylingItem?.fontColor,
    marginTop: 12,
  };

  if (profileUpdateData) {
    if (isProfileFullyCompleteForPermits(profileUpdateData)) {
      return (
        <>
          {toggleAddPermitPage === "view" ? (
            <ViewPermitCart
              StylingItem={StylingItem}
              handletoggleAddPermitPage={handletoggleAddPermitPage}
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              setPermitType={setPermitType}
              permitType={permitType}
            />
          ) : (
              <AddPermitPage
                StylingItem={StylingItem}
                handletoggleAddPermitPage={handletoggleAddPermitPage}
                setSelectedDate={setSelectedDate}
                selectedDate={selectedDate}
                setPermitType={setPermitType}
                permitType={permitType}
                allPermit={permitList}
              />
          )}
        </>
      );
    } else {
      return (
        <>
          <Grid className="permit-page-wrapper permit-bg">
            <Container maxWidth={"xl"}>
              {shouldShowProfileIncompleteForm(
                profileUpdateData,
                ProfileRequiredFields
              ) ? (
                <ProfileIncompleteWarning
                  stylingVal={stylingVal}
                  inCompleteDetails={getIncompleteProfileDetails(
                    profileUpdateData,
                    ProfileRequiredFields
                  )}
                />
              ) : (
                <>
                  {toggleAddPermitPage === "view" ? (
                    <ViewPermitCart
                      StylingItem={StylingItem}
                      handletoggleAddPermitPage={handletoggleAddPermitPage}
                      setSelectedDate={setSelectedDate}
                      selectedDate={selectedDate}
                      setPermitType={setPermitType}
                      permitType={permitType}
                    />
                  ) : (
                    <>
                      {" "}
                      <AddPermitPage
                        StylingItem={StylingItem}
                        handletoggleAddPermitPage={handletoggleAddPermitPage}
                        setSelectedDate={setSelectedDate}
                        selectedDate={selectedDate}
                        setPermitType={setPermitType}
                        permitType={permitType}
                        allPermit={permitList}
                      />
                    </>
                  )}
                </>
              )}
            </Container>
          </Grid>
        </>
      );
    }
  } else {
    return <></>;
  }
};

export default BuyPermitsPage;
